import { useState } from 'react';

export default function AreasSection() {
  const [showMore, setShowMore] = useState(false);

  const initialAreas = [
    "Acampo", "Adelanto", "Ahwahnee", "Alameda", "Alamo", "Alta", "Alturas", "Alviso", 
    "Amador City", "American Canyon", "Anderson", "Angels Camp", "Antelope", "Antioch", 
    "Applegate", "Aptos", "Arboga", "Arbuckle", "Arnold", "Arvin"
  ];

  const additionalAreas = [
    "Atascadero", "Atherton", "Atwater", "Auberry", "Auburn", "Auburn Unincorp", "Bakersfield", 
    "Ballico", "Bangor", "Bay Point", "Bear Valley", "Belmont", "Ben Lomond", "Benicia", 
    "Berkeley", "Berry Creek", "Bethel Island", "Bickford Ranch", "Big Bar", "Big Bear Lake",
    "Big Oak Flat", "Biggs", "Bodega Bay", "Brentwood", "Bridgeville", "Brisbane", "Brooks",
    "Browns Valley", "Brownsville", "Buckhorn", "Bucks Lake", "Burson", "Butte Valley", "Byron",
    "Calaveras", "California City", "Cameron Park", "Camino", "Camp Connell", "Campbell",
    "Campo Seco", "Camptonville", "Canby", "Cantua Creek", "Capay", "Capay Valley", "Carmichael",
    "Carnelian Bay", "Castro Valley", "Catheys Valley", "Cedarville", "Ceres", "Challenge",
    "Chico", "Chilcoot", "Chinese Camp", "Chowchilla", "Citrus Heights", "Clarksburg", "Clayton",
    "Clearlake", "Clearlake Oaks", "Clements", "Clipper Mills", "Clovis", "Coalinga", "Coarsegold",
    "Cold Springs", "Colfax", "College City", "Coloma", "Columbia", "Colusa", "Concord", "Concow",
    "Cool", "Copperopolis", "Corcoran", "Corning", "Cotati", "Cottonwood", "Coulterville",
    "Courtland", "Covelo", "Crescent City", "Cressey", "Crows Landing", "Cupertino", "Daly City",
    "Dana Point", "Danville", "Davis", "Del Norte", "Delhi", "Denair", "Desert Hot Springs",
    "Diamond Springs", "Dinuba", "Discovery Bay", "Dixon", "Dobbins", "Don Pedro", "Dorrington",
    "Dorris", "Dos Palos", "Doyle", "Drytown", "Dublin", "Dunnigan", "Durham", "Dutch Flat",
    "East Palo Alto", "Edwards", "El Cerrito", "El Dorado", "El Dorado Hills", "El Granada",
    "El Macero", "El Sobrante", "Elk Creek", "Elk Grove", "Elverta", "Emeryville", "Emigrant Gap",
    "Empire", "Escalon", "Esparto", "Eugene", "Fair Oaks", "Fair Play", "Fairfield", "Fall River Mills",
    "Farmington", "Feather Falls", "Felton", "Fiddletown", "Firebaugh", "Five Points", "Floriston",
    "Flournoy", "Folsom", "Forbestown", "Forest Knolls", "Foresthill", "Fort Bidwell", "Fort Bragg",
    "Foster City", "Fowler", "Fremont", "French Camp", "French Gulch", "Fresno", "Friant", "Galt",
    "Garberville", "Garden Valley", "Georgetown", "Gerber", "Gilroy", "Glencoe", "Glenhaven",
    "Glenn", "Gold River", "Gold Run", "Goodyears Bar", "Granite Bay", "Grass Valley", "Greenwood",
    "Gridley", "Grimes", "Grizzly Flats", "Groveland", "Gualala", "Guerneville", "Guinda", "Gustine",
    "Hamilton City", "Hanford", "Hathaway Pines", "Hayfork", "Hayward", "Herald", "Hercules",
    "Hickman", "Hidden Hills", "Hidden Valley Lake", "Hillsborough", "Hilmar", "Hollister", "Hood",
    "Hughson", "Huron", "Hyampom", "Indio", "Inyokern", "Ione", "Isleton", "Jackson", "Jamestown",
    "Janesville", "Jenny Lind", "Kelseyville", "Kenwood", "Keyes", "Kings Canyon National Pk",
    "Kingsburg", "Kirkwood", "Knights Ferry", "Knights Landing", "Kyburz", "La Grange", "La Porte",
    "Lagunitas", "Lake Almanor", "Lake City", "Lake Elsinore", "Lake Oroville", "Lake Wildwood",
    "Lakehead", "Lakeport", "Lakewood", "Lancaster", "Lathrop", "Latrobe", "Le Grand", "Lemoore",
    "Lewiston", "Lincoln", "Linda", "Linden", "Lindsay", "Litchfield", "Live Oak", "Livermore",
    "Livingston", "Lockeford", "Lodi", "Lodoga", "Loma Rica", "Long Barn", "Loomis", "Los Angeles",
    "Los Banos", "Los Gatos", "Los Molinos", "Los Osos", "Lost Hills", "Lotus", "Lower Lake",
    "Loyalton", "Lucerne", "Lucerne Valley", "Madera", "Madison", "Magalia", "Manteca", "Manton",
    "Marina", "Mariposa", "Markleeville", "Martinez", "Marysville", "Mather", "Maxwell", "McCloud",
    "Meadow Vista", "Mendota", "Menlo Park", "Merced", "Meridian", "Mi Wuk Village", "Middletown",
    "Midpines", "Milford", "Milpitas", "Mineral", "Miramonte", "Moccasin", "Modesto", "Mokelumne Hill",
    "Montague", "Monterey", "Montgomery Creek", "Moraga", "Morgan Hill", "Moss Beach", "Mount Aukum",
    "Mountain House", "Mountain Ranch", "Murphys", "Murrieta", "Myers Flat", "Napa", "Nevada City",
    "Newark", "Newberry Springs", "Newcastle", "Newman", "Nice", "Nicolaus", "North Fork",
    "North Highlands", "North San Juan", "Novato", "O Neals", "Oak Run", "Oakdale", "Oakhurst",
    "Oakland", "Oakley", "Oceanside", "Olivehurst", "Orange Cove", "Orangevale", "Oregon House",
    "Orland", "Oroville", "Outside California", "Oxnard", "Pacifica", "Palermo", "Paradise",
    "Parlier", "Patterson", "Penn Valley", "Penryn", "Petaluma", "Pilot Hill", "Pine Grove",
    "Pinole", "Pioneer", "Pittsburg", "Placerville", "Planada", "Platina", "Pleasant Grove",
    "Pleasanton", "Plumas Lake", "Plymouth", "Pollock Pines", "Pope Valley", "Porterville",
    "Portola", "Prather", "Princeton", "Quincy", "Rackerby", "Rail Road Flat", "Rancho Cordova",
    "Rancho Murieta", "Raymond", "Red Bluff", "Redding", "Redwood City", "Reedley", "Rescue",
    "Richmond", "Richvale", "Rio Linda", "Rio Oso", "Rio Vista", "Ripon", "River Pines",
    "Riverbank", "Riverside", "Rocklin", "Rodeo", "Rohnert Park", "Roseville", "Rough and Ready",
    "Royal Oaks", "Rumsey", "Ryde", "Sacramento", "Salida", "Salinas", "San Andreas",
    "San Bernardino", "San Bruno", "San Francisco", "San Geronimo", "San Jose", "San Juan Bautista",
    "San Leandro", "San Luis Obispo", "San Martin", "San Mateo", "San Pablo", "San Rafael",
    "San Ramon", "Sanger", "Santa Clara", "Santa Cruz", "Santa Margarita", "Santa Nella",
    "Santa Rosa", "Saratoga", "Sausalito", "Scotts Valley", "Selma", "Shafter", "Shasta",
    "Sheep Ranch", "Sheridan", "Shingle Springs", "Shingletown", "Sierra City", "Sloughhouse",
    "Smartsville", "Snelling", "Soda Springs", "Somerset", "Sonoma", "Sonora", "Soquel",
    "Soulsbyville", "South Dos Palos", "South Lake Tahoe", "South San Francisco", "Squaw Valley",
    "St. Helena", "Stevinson", "Stockton", "Stonyford", "Stratford", "Strathmore", "Strawberry",
    "Strawberry Valley", "Suisun City", "Sunnyvale", "Susanville", "Sutter", "Sutter Creek",
    "Tahoe City", "Tahoe Vista", "Tehachapi", "Terra Bella", "Thornton", "Three Rivers",
    "Tollhouse", "Tomales", "Tracy", "Tranquillity", "Trinity Center", "Truckee", "Tulare",
    "Tulelake", "Tuolumne", "Turlock", "Twain Harte", "Twin Bridges", "Ukiah", "Union City",
    "Upper Lake", "Vacaville", "Vallecito", "Vallejo", "Valley Springs", "Vernalis", "Victorville",
    "Vinton", "Visalia", "Volcano", "Wallace", "Walnut Creek", "Walnut Grove", "Wasco",
    "Washington", "Waterford", "Watsonville", "Weed", "Weimar", "West Point", "West Sacramento",
    "Westley", "Wheatland", "Whitethorn", "Williams", "Willits", "Willows", "Wilseyville",
    "Wilton", "Windsor", "Winters", "Winton", "Woodbridge", "Woodlake", "Woodland", "Yolo",
    "Yosemite National Par", "Yreka", "Yuba City", "Yucca Valley"
  ];

  const displayedAreas = showMore ? [...initialAreas, ...additionalAreas] : initialAreas;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl font-light text-center mb-12">Areas We Cover</h1>
          
          <div className="text-center">
            <ul className="inline-flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
              {displayedAreas.map((area, index) => (
                <li key={index} className="flex items-center">
                  <i className="fa fa-map-marker text-gray-400 mr-2"></i>
                  <a 
                    href={`/areas/${area.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}/ca`}
                    className="text-blue-600 hover:text-blue-700 transition-colors"
                  >
                    {area}
                  </a>
                </li>
              ))}
            </ul>
            
            <div className="mt-8">
              <button
                onClick={() => setShowMore(!showMore)}
                className="text-blue-600 hover:text-blue-700 font-medium transition-colors"
              >
                {showMore ? 'Show Less...' : 'Show More...'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}